import { defineComponent as _defineComponent } from 'vue'
import LinkButton from 'JS/components/LinkButton.vue';
import { ICheckoutPayment } from 'JS/types/Checkout';


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectedPaymentDisplay',
  props: {
    title: null,
    amount: null,
    buttonText: { default: 'Change' },
    buttonLabel: null,
    disabled: { type: Boolean }
  },
  emits: ["update"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'update'): void;
}), expose: any, slots: any, attrs: any }) {





return { __sfc: true,emit, LinkButton }
}

})